"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styling_1 = require("../../styling");
const utils_1 = require("../../styling/utils");
const styles_1 = tslib_1.__importDefault(require("./styles"));
const Icons_1 = tslib_1.__importDefault(require("../Icons"));
function PlayerOverlayButton({ classes = { root: {} }, children, ...rest }) {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: styles_1.default }, "playerOverlayButton");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, styles_1.default);
    return (react_1.default.createElement("div", { ...rest, className: `${rest.disabled ? mergedClasses.rootDisabled : ""} ${mergedClasses.root}` }, children !== null && children !== void 0 ? children : react_1.default.createElement(Icons_1.default, { iconName: "play", classes: mergedStyles.overlayPlayIcon })));
}
exports.default = PlayerOverlayButton;
//# sourceMappingURL=index.js.map